import Vue from 'vue'


import Cookies from 'js-cookie'

import 'normalize.css/normalize.css'

import Element from 'element-ui'
// 文本编辑器模块
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

// 数据字典
import dict from './components/Dict'

// 权限指令
import permission from './components/Permission'
// 初始化css
import './assets/styles/element-variables.scss'
// global css
import './assets/styles/index.scss'

// 引入vue-quill-editor样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 代码高亮
import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/styles/atom-one-dark.css'

// 字体图标 CSS 已移至 public/index.html 通过 <link> 标签直接加载
// 避免 webpack 处理字体文件时因异步 chunk / publicPath 导致路径解析失败、图标乱码
// import '@/assets/font_icon/iconfont.css'
// import '@/assets/font_new/iconfont.css'

import App from './App'
import store from './store'
import router from './router/routers'
import component from './components/index'
import './assets/icons' // icon
import './router/index' // permission control
import dataV from '@jiaminghi/data-view'
// 全局过滤器
import * as filters from './filters'

// 全局自定义主键
import confirmUtil from './utils/confirm'
import {amountFormat,numberFormat,spaceFormat,plateFormat,removeEmptyProperties} from './utils'

// // 调试工具
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()


Vue.prototype.$confirmUtil = confirmUtil
Vue.prototype.$amountFormat = amountFormat
Vue.prototype.$numberFormat = numberFormat
Vue.prototype.$spaceFormat = spaceFormat
Vue.prototype.$plateFormat = plateFormat

Vue.prototype.$removeEmptyProperties = removeEmptyProperties

Element.Dialog.props.closeOnClickModal.default = false


// Vue.use(vConsole);
Vue.use(VueHighlightJS)
Vue.use(mavonEditor)
Vue.use(permission)
Vue.use(component)
Vue.use(dict)
Vue.use(dataV)
Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size
})

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// 是否打印[warn]信息
Vue.config.silent = true
const vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vm
